










import {Component, Vue, Prop} from 'vue-property-decorator'

@Component
export default class PageHeader extends Vue {
  @Prop({required: false}) fixed
  @Prop({default: 56}) height

  visibleBack: boolean = false
  visibleClose: boolean = false

  get customStyle() {
    return {
      height: `${this.height}px`
    }
  }

  get customClass() {
    return {
      'is-fixed': this.fixed !== undefined
    }
  }

  mounted() {
    this.visibleBack = Boolean(this.$listeners.back)
    this.visibleClose = Boolean(this.$listeners.close)
  }

  updated() {
    this.visibleBack = Boolean(this.$listeners.back)
    this.visibleClose = Boolean(this.$listeners.close)
  }
}
